<script setup lang="ts">
import type { VImg } from 'vuetify/components';

type PropsType = {
    src?: string;
    alt?: string;
    width?: string | number;
    height?: string | number;
    maxWidth?: string | number;
    maxHeight?: string | number;
    minWidth?: string | number;
    minHeight?: string | number;
    aspectRatio?: string | number;
    cover?: boolean;
    contain?: boolean;
    lazy?: boolean;
    eager?: boolean;
    position?: VImg['$props']['position'];
    transition?: string | false;
};

withDefaults(defineProps<PropsType>(), {
    alt: '',
    cover: true,
    lazy: true,
    transition: 'fade-transition',
});

const emit = defineEmits<{
    load: [value: string | undefined];
    error: [value: string | undefined];
}>();

const handleLoad = (value: string | undefined) => {
    emit('load', value);
};

const handleError = (value: string | undefined) => {
    emit('error', value);
};

defineOptions({ inheritAttrs: false });
</script>

<template>
    <VImg
        :src="src"
        :alt="alt"
        :width="width"
        :height="height"
        :max-width="maxWidth"
        :max-height="maxHeight"
        :min-width="minWidth"
        :min-height="minHeight"
        :aspect-ratio="aspectRatio"
        :cover="cover"
        :contain="contain"
        :lazy-src="lazy ? src : undefined"
        :eager="eager"
        :position="position"
        :transition="transition"
        v-bind="$attrs"
        @load="handleLoad"
        @error="handleError"
    >
        <slot />
    </VImg>
</template>
